/*
URL: https://www.itl.nist.gov/div898/strd/nls/data/gauss2.shtml
NIST/ITL StRD
Dataset Name:  Gauss2            (Gauss2.dat)

File Format:   ASCII
               Starting Values   (lines 41 to  48)
               Certified Values  (lines 41 to  53)
               Data              (lines 61 to 310)

Procedure:     Nonlinear Least Squares Regression

Description:   The data are two slightly-blended Gaussians on a
               decaying exponential baseline plus normally
               distributed zero-mean noise with variance = 6.25.

Reference:     Rust, B., NIST (1996).









Data:          1 Response  (y)
               1 Predictor (x)
               250 Observations
               Lower Level of Difficulty
               Generated Data

Model:         Exponential Class
               8 Parameters (b1 to b8)

               y = b1*exp( -b2*x ) + b3*exp( -(x-b4)**2 / b5**2 )
                                   + b6*exp( -(x-b7)**2 / b8**2 ) + e


          Starting values                  Certified Values

        Start 1     Start 2           Parameter     Standard Deviation
  b1 =    96.0        98.0         9.9018328406E+01  5.3748766879E-01
  b2 =     0.009       0.0105      1.0994945399E-02  1.3335306766E-04
  b3 =   103.0       103.0         1.0188022528E+02  5.9217315772E-01
  b4 =   106.0       105.0         1.0703095519E+02  1.5006798316E-01
  b5 =    18.0        20.0         2.3578584029E+01  2.2695595067E-01
  b6 =    72.0        73.0         7.2045589471E+01  6.1721965884E-01
  b7 =   151.0       150.0         1.5327010194E+02  1.9466674341E-01
  b8 =    18.0        20.0         1.9525972636E+01  2.6416549393E-01

Residual Sum of Squares:                    1.2475282092E+03
Residual Standard Deviation:                2.2704790782E+00
Degrees of Freedom:                               242
Number of Observations:                           250
 */

const points = [
  [97.58776, 1.0],
  [97.76344, 2.0],
  [96.56705, 3.0],
  [92.52037, 4.0],
  [91.15097, 5.0],
  [95.21728, 6.0],
  [90.21355, 7.0],
  [89.29235, 8.0],
  [91.51479, 9.0],
  [89.60966, 10.0],
  [86.56187, 11.0],
  [85.55316, 12.0],
  [87.13054, 13.0],
  [85.6794, 14.0],
  [80.04851, 15.0],
  [82.18925, 16.0],
  [87.24081, 17.0],
  [80.79407, 18.0],
  [81.2857, 19.0],
  [81.5694, 20.0],
  [79.22715, 21.0],
  [79.43275, 22.0],
  [77.90195, 23.0],
  [76.75468, 24.0],
  [77.17377, 25.0],
  [74.27348, 26.0],
  [73.119, 27.0],
  [73.84826, 28.0],
  [72.4787, 29.0],
  [71.92292, 30.0],
  [66.92176, 31.0],
  [67.93835, 32.0],
  [69.56207, 33.0],
  [69.07066, 34.0],
  [66.53983, 35.0],
  [63.87883, 36.0],
  [69.71537, 37.0],
  [63.60588, 38.0],
  [63.37154, 39.0],
  [60.01835, 40.0],
  [62.67481, 41.0],
  [65.80666, 42.0],
  [59.14304, 43.0],
  [56.62951, 44.0],
  [61.21785, 45.0],
  [54.3879, 46.0],
  [62.93443, 47.0],
  [56.65144, 48.0],
  [57.13362, 49.0],
  [58.29689, 50.0],
  [58.91744, 51.0],
  [58.50172, 52.0],
  [55.22885, 53.0],
  [58.30375, 54.0],
  [57.43237, 55.0],
  [51.69407, 56.0],
  [49.93132, 57.0],
  [53.7076, 58.0],
  [55.39712, 59.0],
  [52.89709, 60.0],
  [52.31649, 61.0],
  [53.9872, 62.0],
  [53.54158, 63.0],
  [56.45046, 64.0],
  [51.32276, 65.0],
  [53.11676, 66.0],
  [53.28631, 67.0],
  [49.80555, 68.0],
  [54.69564, 69.0],
  [56.41627, 70.0],
  [54.59362, 71.0],
  [54.3852, 72.0],
  [60.15354, 73.0],
  [59.78773, 74.0],
  [60.49995, 75.0],
  [65.43885, 76.0],
  [60.70001, 77.0],
  [63.71865, 78.0],
  [67.77139, 79.0],
  [64.70934, 80.0],
  [70.78193, 81.0],
  [70.38651, 82.0],
  [77.22359, 83.0],
  [79.52665, 84.0],
  [80.13077, 85.0],
  [85.67823, 86.0],
  [85.20647, 87.0],
  [90.24548, 88.0],
  [93.61953, 89.0],
  [95.86509, 90.0],
  [93.46992, 91.0],
  [105.8137, 92.0],
  [107.8269, 93.0],
  [114.0607, 94.0],
  [115.5019, 95.0],
  [118.511, 96.0],
  [119.6177, 97.0],
  [122.194, 98.0],
  [126.9903, 99.0],
  [125.7005, 100.0],
  [123.7447, 101.0],
  [130.6543, 102.0],
  [129.7168, 103.0],
  [131.824, 104.0],
  [131.8759, 105.0],
  [131.9994, 106.0],
  [132.1221, 107.0],
  [133.4414, 108.0],
  [133.8252, 109.0],
  [133.6695, 110.0],
  [128.2851, 111.0],
  [126.5182, 112.0],
  [124.755, 113.0],
  [118.4016, 114.0],
  [122.0334, 115.0],
  [115.2059, 116.0],
  [118.7856, 117.0],
  [110.7387, 118.0],
  [110.2003, 119.0],
  [105.1729, 120.0],
  [103.4472, 121.0],
  [94.5428, 122.0],
  [94.40526, 123.0],
  [94.57964, 124.0],
  [88.76605, 125.0],
  [87.28747, 126.0],
  [92.50443, 127.0],
  [86.27997, 128.0],
  [82.44307, 129.0],
  [80.47367, 130.0],
  [78.36608, 131.0],
  [78.74307, 132.0],
  [76.12786, 133.0],
  [79.13108, 134.0],
  [76.76062, 135.0],
  [77.60769, 136.0],
  [77.76633, 137.0],
  [81.2822, 138.0],
  [79.74307, 139.0],
  [81.97964, 140.0],
  [80.02952, 141.0],
  [85.95232, 142.0],
  [85.96838, 143.0],
  [79.94789, 144.0],
  [87.17023, 145.0],
  [90.50992, 146.0],
  [93.23373, 147.0],
  [89.14803, 148.0],
  [93.11492, 149.0],
  [90.34337, 150.0],
  [93.69421, 151.0],
  [95.74256, 152.0],
  [91.85105, 153.0],
  [96.74503, 154.0],
  [87.60996, 155.0],
  [90.47012, 156.0],
  [88.1169, 157.0],
  [85.70673, 158.0],
  [85.01361, 159.0],
  [78.5304, 160.0],
  [81.34148, 161.0],
  [75.19295, 162.0],
  [72.66115, 163.0],
  [69.85504, 164.0],
  [66.29476, 165.0],
  [63.58502, 166.0],
  [58.33847, 167.0],
  [57.50766, 168.0],
  [52.80498, 169.0],
  [50.79319, 170.0],
  [47.0349, 171.0],
  [46.4709, 172.0],
  [43.09016, 173.0],
  [34.11531, 174.0],
  [39.28235, 175.0],
  [32.68386, 176.0],
  [30.44056, 177.0],
  [31.98932, 178.0],
  [23.6333, 179.0],
  [23.69643, 180.0],
  [20.26812, 181.0],
  [19.07074, 182.0],
  [17.59544, 183.0],
  [16.08785, 184.0],
  [18.94267, 185.0],
  [18.61354, 186.0],
  [17.258, 187.0],
  [16.62285, 188.0],
  [13.48367, 189.0],
  [15.37647, 190.0],
  [13.47208, 191.0],
  [15.96188, 192.0],
  [12.32547, 193.0],
  [16.3388, 194.0],
  [10.43833, 195.0],
  [9.628715, 196.0],
  [13.12268, 197.0],
  [8.772417, 198.0],
  [11.76143, 199.0],
  [12.5502, 200.0],
  [11.33108, 201.0],
  [11.20493, 202.0],
  [7.816916, 203.0],
  [6.800675, 204.0],
  [14.26581, 205.0],
  [10.66285, 206.0],
  [8.911574, 207.0],
  [11.56733, 208.0],
  [11.58207, 209.0],
  [11.59071, 210.0],
  [9.730134, 211.0],
  [11.44237, 212.0],
  [11.22912, 213.0],
  [10.17213, 214.0],
  [12.50905, 215.0],
  [6.201493, 216.0],
  [9.019605, 217.0],
  [10.80607, 218.0],
  [13.09625, 219.0],
  [3.914271, 220.0],
  [9.567886, 221.0],
  [8.038448, 222.0],
  [10.23104, 223.0],
  [9.36741, 224.0],
  [7.695971, 225.0],
  [6.118575, 226.0],
  [8.793207, 227.0],
  [7.796692, 228.0],
  [12.45065, 229.0],
  [10.61601, 230.0],
  [6.001003, 231.0],
  [6.765098, 232.0],
  [8.764653, 233.0],
  [4.586418, 234.0],
  [8.390783, 235.0],
  [7.209202, 236.0],
  [10.01209, 237.0],
  [7.327461, 238.0],
  [6.525136, 239.0],
  [2.840065, 240.0],
  [10.32371, 241.0],
  [4.790035, 242.0],
  [8.376431, 243.0],
  [6.26398, 244.0],
  [2.705892, 245.0],
  [8.362109, 246.0],
  [8.983507, 247.0],
  [3.362469, 248.0],
  [1.182678, 249.0],
  [4.875312, 250.0],
]

// const MIN_POINT_DISTANCE = 4
// .reduce((prev, cur) => {
//   if (prev.length === 0) {
//     prev.push(cur)
//   }

//   if (cur.x - prev[prev.length - 1].x > MIN_POINT_DISTANCE) {
//     prev.push(cur)
//   }

//   return prev
// }, [])

export default {
  id: 'gauss2',
  name: 'blended gaussians',
  mutable: false,
  equations: [
    'y = C_1 \\cdot \\exp( -C_2 \\cdot x ) + C_3 \\cdot \\exp\\left(\\frac{-(x-C_4)^2}{C_5^2}\\right) + C_6 \\cdot \\exp\\left(\\frac{-(x-C_7)^2}{C_8^2}\\right)',
  ],
  // array of column indices of the points matrix
  inputs: [1],
  // array of column indices of the points matrix
  outputs: [0],
  // labels for each column of the points matrix
  labels: ['y', 'x'],
  points,
}
